export const capitalize = (x: string) =>
  x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
